(() => {
  'use strict';
  if (customElements.get('hellsinki-product-duo')) return;
  const money = cents => new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents/100);
  const norm = value => String(value).normalize('NFD').replace(/[\u0300-\u036f\s_-]/g,'').toLowerCase();
  const colors = {black:'#111',white:'#fff',navy:'#172844',blue:'#477ca8',green:'#42694d',darkgreen:'#254936',olive:'#777c40',ivory:'#fffff0',tan:'#d2b48c',beige:'#d7c6ae',gray:'#999',grey:'#999',lightyellow:'#faf0bd',brown:'#785644',cream:'#f3ead8',offwhite:'#f7f3e8',pink:'#e7b5c4',red:'#ab3438',preto:'#111',branco:'#fff',azulmarinho:'#172844',azul:'#477ca8',verde:'#42694d',vermelho:'#ab3438',marrom:'#785644',cinza:'#999'};
  const el = (tag,cls,text) => {const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
  customElements.define('hellsinki-product-duo',class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;this.events=new AbortController();const signal=this.events.signal;
      this.product=JSON.parse(this.querySelector('[data-product]').textContent);
      this.text=JSON.parse(this.querySelector('[data-text]').textContent);
      this.form=document.getElementById(this.dataset.formId);
      this.root=this.closest('[data-product-id]')||this.parentElement;
      this.nativeButton=this.form?.querySelector('[data-add-to-cart]');
      const initial=this.product.variants.find(v=>String(v.id)===this.dataset.selectedId)||this.product.variants.find(v=>v.available)||this.product.variants[0];
      this.singleVariant=initial;this.duo=false;
      this.querySelector('[data-duo-pieces]').replaceChildren();
      this.pieces=[0,1].map(index=>this.buildPiece(index,initial));
      this.querySelectorAll('.h-product-duo__offers input').forEach(input=>input.addEventListener('change',()=>{
        this.duo=input.value==='duo';this.querySelector('.h-product-duo__details').hidden=!this.duo;this.refresh();
      },{signal}));
      this.root.addEventListener('variantChange',event=>{
        const variant=event.detail?.variant;if(!variant)return;
        this.singleVariant=variant;this.pieces[0].selected=variant.options.slice();this.renderPiece(this.pieces[0]);
        if(!this.duo){this.pieces[1].selected=variant.options.slice();this.renderPiece(this.pieces[1]);}
        this.refresh();
      },{signal});
      this.form?.addEventListener('submit',event=>{
        if(!this.duo)return;event.preventDefault();event.stopImmediatePropagation();this.addDuo();
      },{capture:true,signal});
      this.refresh();
    }
    disconnectedCallback(){this.events?.abort();this.initialized=false;}
    buildPiece(index,variant){
      const field=el('fieldset','h-product-duo__piece');field.dataset.piece=String(index);
      field.append(el('legend','',index===0?this.text.first:this.text.second));
      const summary=el('div','h-product-duo__summary'),image=el('img','h-product-duo__image');
      image.width=58;image.height=74;image.loading='lazy';image.alt=this.product.title;
      summary.append(image,el('span','h-product-duo__name',this.product.title));field.append(summary);
      const options=el('div','h-product-duo__options');field.append(options);this.querySelector('[data-duo-pieces]').append(field);
      const piece={index,field,image,options,selected:variant.options.slice()};this.renderPiece(piece);return piece;
    }
    variant(piece){return this.product.variants.find(v=>v.options.every((value,index)=>value===piece.selected[index]));}
    renderPiece(piece){
      piece.options.replaceChildren();let groups=0;
      this.product.options.forEach((option,position)=>{
        const name=typeof option==='string'?option:option.name,values=[...new Set(this.product.variants.map(v=>v.options[position]))];
        if(norm(name)==='title'&&values.length===1&&values[0]==='Default Title')return;
        groups++;const color=/cor|color|colour/.test(norm(name)),group=el('div','h-product-duo__option');
        group.setAttribute('role','group');group.setAttribute('aria-label',name);
        group.append(el('span','h-product-duo__label',`${name}: ${piece.selected[position]}`));
        const choices=el('div','h-product-duo__choices');
        values.forEach(value=>{
          const button=el('button',`h-product-duo__choice${color?' h-product-duo__choice--color':''}`,color?undefined:value.toUpperCase());
          button.type='button';button.title=value;button.setAttribute('aria-label',value);button.setAttribute('aria-pressed',String(piece.selected[position]===value));
          button.disabled=!this.product.variants.some(v=>v.available&&v.options[position]===value&&v.options.every((entry,index)=>index===position||entry===piece.selected[index]));
          if(color){const swatch=el('span'),candidate=colors[norm(value)]||value;swatch.style.backgroundColor=CSS.supports('color',candidate)?candidate:'#ddd';button.append(swatch);}
          button.addEventListener('click',()=>{
            piece.selected[position]=value;this.renderPiece(piece);this.refresh();
            [...piece.options.querySelectorAll('button')].find(next=>next.getAttribute('aria-label')===value)?.focus({preventScroll:true});
          });choices.append(button);
        });group.append(choices);piece.options.append(group);
      });
      if(!groups)piece.options.append(el('span','h-product-duo__label',this.text.unique));
      const variant=this.variant(piece),image=variant?.featured_image?.src||this.product.featured_image;
      if(image)piece.image.src=image+(image.includes('?')?'&':'?')+'width=140';
    }
    refresh(){
      const variants=this.pieces.map(piece=>this.variant(piece)),ready=variants.every(v=>v?.available);
      this.total=ready?Math.round(variants.reduce((sum,v)=>sum+v.price,0)*90/100):null;
      this.querySelector('[data-single-price]').textContent=money(this.singleVariant.price);
      this.querySelector('[data-duo-price]').textContent=this.total===null?'—':money(this.total);
      this.querySelector('[data-duo-total]').textContent=this.total===null?'—':money(this.total);
      if(this.nativeButton)this.nativeButton.disabled=this.duo?(!ready||this.busy):!this.singleVariant.available;
    }
    async addDuo(){
      if(this.busy||this.pieces.some(piece=>!this.variant(piece)?.available))return;
      this.busy=true;this.refresh();const status=this.querySelector('.h-product-duo__error');status.hidden=true;
      const text=this.nativeButton?.querySelector('[data-add-to-cart-text]'),previous=text?.textContent;if(text)text.textContent=this.text.adding;
      try{
        const grouped=new Map();this.pieces.forEach(piece=>{const id=this.variant(piece).id;grouped.set(id,(grouped.get(id)||0)+1);});
        const response=await fetch(`${this.dataset.root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[...grouped].map(([id,quantity])=>({id,quantity}))})});
        if(!response.ok)throw Error('cart');await response.json();
        document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:open'));
      }catch(_){status.textContent=this.text.error;status.hidden=false;}
      finally{this.busy=false;if(text)text.textContent=previous;this.refresh();}
    }
  });
})();
